try {

(function(){ function medir(){ var h=document.querySelector('.nv-hero'), a=document.querySelector('.nv-spec'), z=document.querySelector('.nv-var'); if(!h||!a||!z) return;
  var t=h.getBoundingClientRect().top, y=a.getBoundingClientRect().top-t, b=z.getBoundingClientRect().bottom-t;
  h.style.setProperty('--ry', Math.round(y)+'px'); var g=document.querySelector('.nv-tabs'); if(g) h.style.setProperty('--gy', Math.round(g.getBoundingClientRect().top-t)+'px'); h.style.setProperty('--rh', Math.max(40, Math.round(b-y))+'px'); }
  if(document.readyState!=='loading') medir(); else document.addEventListener('DOMContentLoaded', medir);
  addEventListener('load', medir); addEventListener('resize', medir); if(document.fonts&&document.fonts.ready) document.fonts.ready.then(medir); })();

} catch (e) { console.error(e); }
try {

(() => {
  if (!('IntersectionObserver' in window)) { document.documentElement.classList.remove('js'); return; }
  const ver = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('vis'); ver.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.rv').forEach(el => ver.observe(el));
  const barra = document.querySelector('.barra'), hero = document.querySelector('header.nv-hero') || document.querySelector('.hero .btn'), ofe = document.getElementById('oferta'), ped = document.getElementById('pedir');
  let a = true, b = false, c = false; const up = () => barra.classList.toggle('oculta', a || b || c);
  new IntersectionObserver(es => { a = es[es.length - 1].isIntersecting; up(); }).observe(hero);
  new IntersectionObserver(es => { b = es[es.length - 1].isIntersecting; up(); }).observe(ofe);
  new IntersectionObserver(es => { c = es[es.length - 1].isIntersecting; up(); }).observe(ped);
})();

} catch (e) { console.error(e); }
try {

document.querySelectorAll('[data-car]').forEach(c => {
  const t = c.querySelector('.car-track'), sl = [...t.children], d = c.querySelector('.car-dots');
  sl.forEach(() => d.appendChild(document.createElement('i')));
  const dots = [...d.children];
  const upd = () => { const x = t.scrollLeft + t.clientWidth / 2; let k = 0, best = 1e9; sl.forEach((e, n) => { const m = Math.abs(e.offsetLeft + e.offsetWidth / 2 - x); if (m < best) { best = m; k = n; } }); dots.forEach((e, n) => e.classList.toggle('on', n === k)); };
  t.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true }); upd();
  c.querySelectorAll('.car-btn').forEach(b => b.addEventListener('click', () => t.scrollBy({ left: b.dataset.dir * (sl[0].offsetWidth + 12), behavior: 'smooth' })));
});

} catch (e) { console.error(e); }
try {

// Modelo 5" o 6": los dos selectores (portada y pedido) y la barra van sincronizados.
// Si el enlace del anuncio trae ?modelo=6, la página abre con el de 6" elegido.
(() => {
  const PR = { '5': '$450.000', '6': '$450.000', '2': '$849.900' };
  const cards = [...document.querySelectorAll('.nv-op[data-var]')], radios = [...document.querySelectorAll('input[name="var"]')], barra = document.querySelector('.nv-barra-pr');
  const pick = v => {
    cards.forEach(c => { const on = c.dataset.var === v; c.classList.toggle('on', on); c.setAttribute('aria-checked', on); });
    radios.forEach(r => { r.checked = r.value === v; });
    if (barra) barra.textContent = PR[v];
    const duo = document.querySelector('.nv-duo'); if (duo && v !== '2') duo.dataset.on = v;
    const m = document.querySelector('.nv-modelo'); if (m) m.textContent = v === '6' ? 'Power DVR NavPro 6"' :'Power DVR NavPro 6"';
    document.dispatchEvent(new CustomEvent('nv:modelo', { detail: v }));
  };
  cards.forEach(c => c.addEventListener('click', () => pick(c.dataset.var)));
  radios.forEach(r => r.addEventListener('change', () => pick(r.value)));
  const q = new URLSearchParams(location.search).get('modelo') && null; // v49: solo 5"
  pick(q === '6' ? '6' : '5');
})();

} catch (e) { console.error(e); }
try {

// Releasit (contraentrega) en modo ventana, con su botón flotante escondido: cualquier botón que lleve a #pedir lo abre.
// Si Releasit aún no cargó, el enlace baja a #pedir. Igual que en el inmovilizador.
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#pedir"]');
  if (!a) return;
  var b = document.getElementById('rsi_buy_now_button');
  if (b) { e.preventDefault(); b.click(); }
});
// Pendiente al montar en Shopify: pasar el modelo elegido a la variante del producto (5" o 6").

} catch (e) { console.error(e); }
try {

(() => {
  const barra = document.querySelector('.progreso span'); if (!barra) return;
  let pend = false;
  const pintar = () => { pend = false; const max = document.documentElement.scrollHeight - innerHeight; barra.style.transform = `scaleX(${max > 0 ? Math.min(scrollY / max, 1) : 0})`; };
  addEventListener('scroll', () => { if (!pend) { pend = true; requestAnimationFrame(pintar); } }, { passive: true });
  addEventListener('resize', pintar); pintar();
})();

} catch (e) { console.error(e); }
try {

// Pantalla viva: encaja un div de 424×300 en las 4 esquinas reales de la pantalla de la foto (homografía → matrix3d).
(() => {
  const scr = document.querySelector('.nv-scr'), img = document.querySelector('.nv-duo img[data-var="5"]'), duo = document.querySelector('.nv-duo');
  if (!scr || !img || !duo) return;
  duo.appendChild(scr);
  const Q = [[42,25],[734,25],[734,350],[42,350]], IW = 776, IH = 370, W = 550, H = 258; // esquinas en la foto original
  function adj(m){return[m[4]*m[8]-m[5]*m[7],m[2]*m[7]-m[1]*m[8],m[1]*m[5]-m[2]*m[4],m[5]*m[6]-m[3]*m[8],m[0]*m[8]-m[2]*m[6],m[2]*m[3]-m[0]*m[5],m[3]*m[7]-m[4]*m[6],m[1]*m[6]-m[0]*m[7],m[0]*m[4]-m[1]*m[3]];}
  function mul(a,b){const c=[];for(let i=0;i<3;i++)for(let j=0;j<3;j++){let s=0;for(let k=0;k<3;k++)s+=a[3*i+k]*b[3*k+j];c[3*i+j]=s;}return c;}
  function mv(m,v){return[m[0]*v[0]+m[1]*v[1]+m[2]*v[2],m[3]*v[0]+m[4]*v[1]+m[5]*v[2],m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];}
  function basis(p){const m=[p[0][0],p[1][0],p[2][0],p[0][1],p[1][1],p[2][1],1,1,1];const v=mv(adj(m),[p[3][0],p[3][1],1]);return mul(m,[v[0],0,0,0,v[1],0,0,0,v[2]]);}
  function fit(){
    if (duo.dataset.on !== '5') { scr.classList.remove('on'); return; }
    const fr = duo.getBoundingClientRect(), r = img.getBoundingClientRect(), sx = r.width / IW, sy = r.height / IH;
    if (!img.complete || r.width < 40 || getComputedStyle(img).opacity < .9 || !duo.classList.contains('giro-ok')) { setTimeout(fit, 250); return; }
    const dst = Q.map(([x,y]) => [r.left - fr.left + x*sx, r.top - fr.top + y*sy]);
    const src = [[0,0],[W,0],[W,H],[0,H]];
    const t = mul(basis(dst), adj(basis(src)));
    const m = t.map(v => v / t[8]);
    scr.style.transform = `matrix3d(${m[0]},${m[3]},0,${m[6]},${m[1]},${m[4]},0,${m[7]},0,0,1,0,${m[2]},${m[5]},0,1)`;
    if (!scr.classList.contains('on')) { scr.classList.add('boot'); clearTimeout(scr._b); scr._b = setTimeout(() => { scr.classList.remove('boot'); scr.dataset.app = 'mapa'; duo.classList.add('hs-on'); scr.classList.add('splash'); setTimeout(() => scr.classList.remove('splash'), 1300); clearTimeout(scr._c); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) (function ciclo(){ const ORD = ['mapa','musica','llamada','llantas'], DUR = { mapa: 5000, musica: 3800, llamada: 4600, llantas: 4200 };
          scr._c = setTimeout(() => { const sig = ORD[(ORD.indexOf(scr.dataset.app) + 1) % ORD.length]; if (sig === 'llamada') scr.dispatchEvent(new Event('nv:llamada')); scr.dataset.app = sig;
            if (sig === 'mapa') { scr.classList.add('splash'); setTimeout(() => scr.classList.remove('splash'), 1300); }
            if (sig === 'llantas') { scr.classList.remove('ll-fin'); scr.querySelectorAll('.ll-dato b').forEach(b => { const to = +b.dataset.to, t0 = performance.now(); const paso = t => { const k = Math.min((t - t0) / 1200, 1); b.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(paso); else scr.classList.add('ll-fin'); }; requestAnimationFrame(paso); }); }
            ciclo(); }, DUR[scr.dataset.app] || 3000); })(); }, 3800); }
    scr.classList.add('on');
  }
  addEventListener('resize', fit); img.addEventListener('transitionend', fit); img.addEventListener('load', fit);
  document.addEventListener('nv:modelo', () => { scr.classList.remove('on'); setTimeout(fit, 850); });
  setTimeout(fit, 950); fit();
})();

} catch (e) { console.error(e); }
try {

// Etiquetas técnicas: aparecen cuando termina el arranque de la pantalla. Parallax suave del producto al bajar.
(() => {
  const duo = document.querySelector('.nv-duo'); if (!duo) return;
  setTimeout(() => duo.classList.add('hs-on'), 6000); // respaldo: normalmente salen al entrar CarPlay
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { duo.classList.add('hs-on'); return; }
  let pend = false;
  addEventListener('scroll', () => { if (pend) return; pend = true; requestAnimationFrame(() => { pend = false; const y = Math.min(scrollY, 700); duo.style.translate = `0 ${y * .12}px`; }); }, { passive: true });
})();

} catch (e) { console.error(e); }
try {

// v24: transformación. La foto de lado (pantalla apagada) se convierte en la frontal: la frontal arranca deformada en
// perspectiva con sus 4 esquinas de pantalla exactamente sobre las de la foto de lado y se endereza cuadro a cuadro.
(() => {
  const duo = document.querySelector('.nv-duo'), img = duo && duo.querySelector('img[data-var="5"]'); if (!img) return;
  const listo = () => { if (duo.classList.contains('giro-ok')) return; img.style.removeProperty('transform'); duo.classList.add('giro-ok'); };
  duo.classList.add('giro-ok'); return; // 6": sin giro desde la foto de lado
  const adj=m=>[m[4]*m[8]-m[5]*m[7],m[2]*m[7]-m[1]*m[8],m[1]*m[5]-m[2]*m[4],m[5]*m[6]-m[3]*m[8],m[0]*m[8]-m[2]*m[6],m[2]*m[3]-m[0]*m[5],m[3]*m[7]-m[4]*m[6],m[1]*m[6]-m[0]*m[7],m[0]*m[4]-m[1]*m[3]];
  const mul=(a,b)=>{const c=[];for(let i=0;i<3;i++)for(let j=0;j<3;j++){let s=0;for(let k=0;k<3;k++)s+=a[3*i+k]*b[3*k+j];c[3*i+j]=s;}return c;};
  const mv=(m,v)=>[m[0]*v[0]+m[1]*v[1]+m[2]*v[2],m[3]*v[0]+m[4]*v[1]+m[5]*v[2],m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];
  const basis=p=>{const m=[p[0][0],p[1][0],p[2][0],p[0][1],p[1][1],p[2][1],1,1,1];const v=mv(adj(m),[p[3][0],p[3][1],1]);return mul(m,[v[0],0,0,0,v[1],0,0,0,v[2]]);};
  const m3d=(src,dst)=>{const t=mul(basis(dst),adj(basis(src)));const m=t.map(v=>v/t[8]);return `matrix3d(${m[0]},${m[3]},0,${m[6]},${m[1]},${m[4]},0,${m[7]},0,0,1,0,${m[2]},${m[5]},0,1)`;};
  const FQ = [[112,96],[663,96],[663,397],[112,397]];      // pantalla en x-n5f (776×464)
  const LQ = [[57,80],[486,50],[480,388],[48,382]];        // pantalla en x-n5-off (776×589)
  const lado = new Image(); lado.className = 'nv-img nv-lado'; lado.dataset.var = '5'; lado.alt = ''; lado.src = '/cdn/shop/files/nv6p-x-n5-off.webp';
  const ease = t => t < .5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2;
  let src, ini, fin, base = '';
  const preparar = () => {
    const W = img.offsetWidth, hf = W * 464 / 776, hl = W * 589 / 776, k = W / 776, s = 1.13, tx = W * .156, ty = W * .215;
    // todo en coordenadas de la caja de la frontal (antes de su translate 0 9 %)
    src = FQ.map(([x,y]) => [x*k, y*k]);
    fin = src;
    ini = LQ.map(([x,y]) => [tx + s*x*k, (hf - hl) + ty + s*y*k - .09*hf]);
    lado.style.translate = tx + 'px ' + ty + 'px';
    const bt = getComputedStyle(img).transform; base = bt && bt !== 'none' ? bt + ' ' : ''; // conserva su centrado propio
    img.style.setProperty('transform-origin', '0 0', 'important');
    img.style.setProperty('transform', base + m3d(src, ini), 'important');
  };
  const correr = () => {
    duo.classList.add('girando'); lado.classList.add('sale');
    const t0 = performance.now(), D = 2400;
    const paso = now => { const e = ease(Math.min((now - t0) / D, 1));
      const q = ini.map((p, i) => [p[0] + (fin[i][0] - p[0]) * e, p[1] + (fin[i][1] - p[1]) * e]);
      img.style.setProperty('transform', base + m3d(src, q), 'important');
      if (e < 1) requestAnimationFrame(paso); else { lado.remove(); listo(); } };
    requestAnimationFrame(paso);
  };
  const arrancar = () => { preparar(); img.after(lado); requestAnimationFrame(() => requestAnimationFrame(() => lado.classList.add('ver'))); setTimeout(correr, 1500); };
  // v25: sin vista de lado. La pantalla aparece de frente (fundido suave) y enseguida arranca POWER.
  const ok = () => setTimeout(() => { duo.classList.add('girando'); setTimeout(listo, 700); }, 200);
  img.complete ? ok() : img.addEventListener('load', ok, { once: true });
  setTimeout(listo, 3000);
})();

} catch (e) { console.error(e); }
try {

// v27: centra el producto (y la marca NAVPRO) en el punto medio exacto de los 4 puntos rojos.
(() => {
  const duo = document.querySelector('.nv-duo'), img = duo && duo.querySelector('img[data-var="5"]'), ds = duo ? [...duo.querySelectorAll('.hs .hs-d')] : [];
  if (!img || ds.length !== 4) return;
  let x = 0, y = 0, ocupado = false;
  const centrar = () => {
    if (ocupado) return;
    const fr = duo.getBoundingClientRect(), r = img.getBoundingClientRect();
    if (r.width < 40) return;
    const c = ds.map(d => d.getBoundingClientRect()), cx = c.reduce((a, b) => a + b.left + b.width / 2, 0) / 4, cy = c.reduce((a, b) => a + b.top + b.height / 2, 0) / 4;
    const dx = cx - (r.left + r.width / 2), dy = cy - (r.top + r.height / 2);
    duo.style.setProperty('--wy', ((cy - fr.top) / fr.height * 100) + '%');
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) { listoCentro(); return; }
    x += dx; y += dy; img.style.setProperty('--nx', x + 'px'); img.style.setProperty('--ny', y + 'px');
    ocupado = true; dispatchEvent(new Event('resize')); ocupado = false; // la pantalla viva se vuelve a encajar
    listoCentro();
  };
  // v29: el producto solo se muestra cuando ya quedó centrado; luego pasa un reflejo solo sobre él
  const listoCentro = () => {
    if (duo.classList.contains('centrado')) return;
    duo.classList.add('centrado');
    const b = document.createElement('i'); b.className = 'nv-brillo'; b.setAttribute('aria-hidden', 'true'); duo.appendChild(b);
    setTimeout(() => { const fr = duo.getBoundingClientRect(), r = img.getBoundingClientRect();
      Object.assign(b.style, { left: (r.left - fr.left) + 'px', top: (r.top - fr.top) + 'px', width: r.width + 'px', height: r.height + 'px' });
      b.classList.add('va'); setTimeout(() => b.remove(), 1600); }, 750);
  };
  setTimeout(listoCentro, 2500); // por si algo falla, que el producto no quede oculto
  addEventListener('resize', centrar);
  img.complete ? centrar() : img.addEventListener('load', centrar, { once: true });
  setTimeout(centrar, 300); setTimeout(centrar, 1200); document.addEventListener('nv:modelo', () => setTimeout(centrar, 50));
})();

} catch (e) { console.error(e); }
try {

// v32: resalta el punto que corresponde a lo que muestra la pantalla viva (ruta o música).
(() => {
  const scr = document.querySelector('.nv-scr'), hs = [...document.querySelectorAll('.nv-duo .hs')]; if (!scr || !hs.length) return;
  const mapa = { mapa: 'ruta', musica: 'musica', llamada: 'llamadas', llantas: 'llantas' };
  const marcar = () => { const a = mapa[scr.dataset.app]; hs.forEach(h => h.classList.toggle('vivo', !!a && h.dataset.app === a)); };
  const sub = document.querySelector('.nt-sub');
  const frase = () => { const t = (typeof ts !== 'undefined' ? ts : hs).find(x => x.dataset.app === scr.dataset.app); if (!sub || !t) return; const txt = t.querySelector('span').childNodes[1].textContent; sub.classList.add('cambia'); setTimeout(() => { sub.textContent = txt; sub.classList.remove('cambia'); }, 300); };
  new MutationObserver(() => { marcar(); frase(); }).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); marcar(); frase();
})();

} catch (e) { console.error(e); }
try {

// v36: llamada entrante → contesta sola a los 1,6 s → contador de tiempo.
(() => {
  const scr = document.querySelector('.nv-scr'); if (!scr) return; let t1, t2;
  const tm = scr.querySelector('.cl-time');
  new MutationObserver(() => {
    if (scr.dataset.app !== 'llamada') { scr.classList.remove('cl-on'); clearTimeout(t1); clearInterval(t2); return; }
    if (t1 && scr.dataset._cl === '1') return; scr.dataset._cl = '1';
    scr.classList.remove('cl-on'); tm.textContent = '00:00'; clearTimeout(t1); clearInterval(t2);
    t1 = setTimeout(() => { scr.classList.add('cl-on'); let n = 0; t2 = setInterval(() => { n++; tm.textContent = '00:0' + Math.min(n, 9); }, 1000); }, 1600);
  }).observe(scr, { attributes: true, attributeFilter: ['data-app'] });
  new MutationObserver(() => { if (scr.dataset.app !== 'llamada') delete scr.dataset._cl; }).observe(scr, { attributes: true, attributeFilter: ['data-app'] });
})();

} catch (e) { console.error(e); }
try {

// v37: la tarjeta del momento se resalta y su línea roja avanza mientras dura ese turno.
(() => {
  const scr = document.querySelector('.nv-scr'), ts = [...document.querySelectorAll('.nv-tabs .nt')]; if (!scr || !ts.length) return;
  const DUR = { mapa: 5000, musica: 3800, llamada: 4600, llantas: 4200 };
  const marcar = () => { const a = scr.dataset.app; ts.forEach(t => { const on = t.dataset.app === a; if (on) { t.classList.remove('on'); void t.offsetWidth; t.style.setProperty('--dur', (DUR[a] || 4000) + 'ms'); } t.classList.toggle('on', on); }); };
  const sub = document.querySelector('.nt-sub');
  const frase = () => { const t = (typeof ts !== 'undefined' ? ts : hs).find(x => x.dataset.app === scr.dataset.app); if (!sub || !t) return; const txt = t.querySelector('span').childNodes[1].textContent; sub.classList.add('cambia'); setTimeout(() => { sub.textContent = txt; sub.classList.remove('cambia'); }, 300); };
  new MutationObserver(() => { marcar(); frase(); }).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); marcar(); frase();
})();

} catch (e) { console.error(e); }
try {

// v54: cada escenario tiene su propia secuencia (orientación: h,v · desmontar: h,off). Arranca al verse.
(() => {
  const DUR = { h: 2800, v: 3000, off: 4200 };
  document.querySelectorAll('.gr-stage').forEach(st => {
    const sec = st.closest('section'), ps = [...sec.querySelectorAll('.gr-steps span')], ORD = (st.dataset.ord || 'h,v').split(',');
    const dur = k => (k === 'h' && ORD.includes('off')) ? 1600 : DUR[k];
    let i = 0, t, corre = false;
    const pon = k => { st.dataset.st = k; ps.forEach(p => { const on = p.dataset.st === k; if (on) { p.classList.remove('on'); void p.offsetWidth; p.style.setProperty('--dur', dur(k) + 'ms'); } p.classList.toggle('on', on); }); };
    const paso = () => { pon(ORD[i]); t = setTimeout(() => { i = (i + 1) % ORD.length; paso(); }, dur(ORD[i])); };
    pon(ORD[0]);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting && !corre) { corre = true; paso(); } else if (!e.isIntersecting && corre) { corre = false; clearTimeout(t); } }), { threshold: .35 }).observe(st);
  });
})();

} catch (e) { console.error(e); }
try {

// v63: la animación de desmontar empieza desde cero cuando se ve y se pausa fuera de pantalla.
(() => {
  const sp = document.querySelector('.sp'), tx = document.querySelector('.sp-txt'); if (!sp) return;
  const els = [...sp.querySelectorAll('*'), ...(tx ? tx.querySelectorAll('span') : [])];
  const set = on => els.forEach(e => e.getAnimations().forEach(a => { if (on) { a.currentTime = 0; a.play(); } else a.pause(); }));
  requestAnimationFrame(() => set(false));
  new IntersectionObserver(es => es.forEach(e => set(e.isIntersecting)), { threshold: .4 }).observe(sp);
})();

} catch (e) { console.error(e); }
try {

// Etiquetas que se tocan: muestran un dato corto abajo del producto; se cierra sola a los 2,8 s.
(() => {
  const pop = document.querySelector('.hs-pop'); if (!pop) return; let t;
  const abrir = h => { document.querySelectorAll('.hs.act').forEach(x => x.classList.remove('act')); h.classList.add('act'); pop.textContent = h.dataset.info; pop.classList.add('on'); clearTimeout(t); t = setTimeout(() => { pop.classList.remove('on'); h.classList.remove('act'); }, 2800); };
  document.querySelectorAll('.hs[data-info]').forEach(h => { h.addEventListener('click', () => abrir(h)); h.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(h); } }); });
})();

} catch (e) { console.error(e); }
try {
/* v83: el punto del sello queda justo en el borde derecho de la página */
(function(){const b=document.querySelector('.nv-t2 .nv-badge');if(!b)return;
function ub(){b.style.setProperty('margin-left','0px','important');const r=b.getBoundingClientRect(),w=document.documentElement.clientWidth;b.style.setProperty('margin-left',(w-(r.left+r.width/2))+'px','important');}
addEventListener('load',ub);addEventListener('resize',ub);if(document.fonts)document.fonts.ready.then(ub);})();
} catch (e) { console.error(e); }
try {
/* v91: las líneas rojas del hero siguen la altura del precio */
(function(){const h=document.querySelector('.nv-hero'),b=document.querySelector('.nv-op.on b');if(!h||!b)return;
function ub(){const hr=h.getBoundingClientRect(),br=b.getBoundingClientRect();const bd=document.querySelector('.nv-t2 .nv-badge');if(bd)h.style.setProperty('--bdy',Math.round(bd.getBoundingClientRect().bottom-hr.top)+'px');h.style.setProperty('--pry',Math.round(br.top-hr.top+br.height/2-30)+'px');}
addEventListener('load',ub);addEventListener('resize',ub);if(document.fonts)document.fonts.ready.then(ub);})();
} catch (e) { console.error(e); }
try {

/* v71 · los videos del problema arrancan solo cuando se ven */
(function () {
  const vs = document.querySelectorAll('.pb-v video'); if (!vs.length) return;
  if (!('IntersectionObserver' in window)) { vs.forEach(v => { v.preload = 'auto'; v.play().catch(() => {}); }); return; }
  const io = new IntersectionObserver(es => es.forEach(e => { const v = e.target; if (e.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); } }), { threshold: .4 });
  vs.forEach(v => io.observe(v));
})();

} catch (e) { console.error(e); }
try {

/* v107 · hilo conductor entre secciones */
(function () {
  const ss = document.querySelectorAll('.panel > .sec'); if (!ss.length) return;
  const hs = [...ss].map(sec => { const h = document.createElement('i'); h.className = 'hilo'; h.setAttribute('aria-hidden', 'true'); sec.prepend(h); return h; });
  if (!('IntersectionObserver' in window)) { hs.forEach(h => h.classList.add('vis')); return; }
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('vis'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -15% 0px' });
  hs.forEach(h => io.observe(h));
})();

} catch (e) { console.error(e); }
try {

/* v120 · los metros del giro van bajando en la pantalla vertical */
(function () { const m = document.querySelector('.cpx-m'); if (!m) return; let v = 260;
  setInterval(() => { v -= 10; if (v < 40) v = 260; m.textContent = v; }, 900); })();

} catch (e) { console.error(e); }
try {

/* v124 · «suspiro» en negro solo a mitad del giro (horizontal ⇄ vertical); al cargar arranca normal en horizontal, sin negro */
(function () {
  const st = document.querySelector('.gr-stage'), scr = st && st.querySelector('.gr-scr'); if (!scr) return;
  let prev = st.getAttribute('data-st'), t1, t2; scr.classList.toggle('vert', prev === 'v');
  new MutationObserver(() => {
    const now = st.getAttribute('data-st');
    if (now === prev) return;
    const gira = (prev === 'h' && now === 'v') || (prev === 'v' && now === 'h');
    prev = now; if (!gira) return;
    scr.classList.remove('suspiro2'); void scr.offsetWidth; scr.classList.add('suspiro2');
    clearTimeout(t1); clearTimeout(t2);
    t2 = setTimeout(() => scr.classList.toggle('vert', now === 'v'), 550);
    t1 = setTimeout(() => scr.classList.remove('suspiro2'), 1200);
  }).observe(st, { attributes: true, attributeFilter: ['data-st'] });
})();

} catch (e) { console.error(e); }
try {

/* v130 · el número 01/02 se alinea con la fila del selector Horizontal · Vertical */
(function () {
  const st = document.querySelector('.gr-sec .gr-stage'), n = st && st.querySelector('.gr-num'), tabs = document.querySelector('.gr-sec .gr-steps');
  if (!n || !tabs) return;
  const ub = () => { const a = st.getBoundingClientRect(), b = tabs.getBoundingClientRect(); st.style.setProperty('--gn-top', (b.top + b.height / 2 - a.top) + 'px'); };
  addEventListener('load', ub); addEventListener('resize', ub); if (document.fonts) document.fonts.ready.then(ub); ub();
})();

} catch (e) { console.error(e); }
try {

// v2 · cifras de llantas que suben y línea de los pasos, al entrar en pantalla
(() => {
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return; io.unobserve(e.target);
    if (e.target.classList.contains('pasos')) { e.target.classList.add('in'); return; }
    const fin = +e.target.dataset.cuenta, t0 = performance.now();
    const paso = t => { const k = Math.min(1, (t - t0) / 1200); e.target.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(paso); };
    requestAnimationFrame(paso);
  }), { threshold: .4 });
  document.querySelectorAll('[data-cuenta], .pasos').forEach(el => io.observe(el));
})();

} catch (e) { console.error(e); }
try {

// v2i: reloj de grabación mientras la pantalla muestra las cámaras
(() => { const scr = document.querySelector('.nv-scr'), t = scr && scr.querySelector('.cm-t'); if (!t) return; let iv;
  new MutationObserver(() => { clearInterval(iv); if (scr.dataset.app !== 'camaras') return; let n = 0; t.textContent = '00:00';
    iv = setInterval(() => { n++; t.textContent = '00:' + String(n).padStart(2, '0'); }, 1000); }).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); })();

} catch (e) { console.error(e); }
try {

// v3: ubica la luna y el dial a partir de donde termina el texto, y hace girar las características como un velocímetro.
(() => {
  const hero = document.querySelector('.nv-hero'), esp = hero && hero.querySelector('.lh-esp'), giro = hero && hero.querySelector('.lh-giro');
  if (!hero || !esp || !giro) return;
  const ubicar = () => {
    const w = innerWidth >= 600 ? Math.min(hero.clientWidth, 520) : Math.min(hero.clientWidth, innerWidth >= 1200 ? 1040 : 760); hero.style.setProperty('--w', w + 'px');
    const top = esp.getBoundingClientRect().top - hero.getBoundingClientRect().top;
    const fondoLuna = top + w * .175, cy = fondoLuna - w * 1.1;
    hero.style.setProperty('--luna-top', (cy - w * 1.1) + 'px');
    hero.style.setProperty('--dial-top', (cy - w * 1.24) + 'px');
  };
  ubicar(); addEventListener('resize', ubicar); addEventListener('load', ubicar); [300, 900, 2000, 3500].forEach(t => setTimeout(ubicar, t));
  const F = [
    ['<span class="lh-t">Navegación</span><span class="lh-s">Waze y Maps</span>', '<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>', 'mapa'],
    ['<span class="lh-t">Tu música</span><span class="lh-s">Sin el celular</span>', '<path d="M9 18V6l11-2v12"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/>', 'musica'],
    ['<span class="lh-t">Gestiona</span><span class="lh-s">Tus llamadas</span>', '<path d="M6.6 3.5 9.4 6.6 7.8 9.3a12 12 0 0 0 6.9 6.9l2.7-1.6 3.1 2.8-1.5 3.1C11 20.6 3.4 13 3.5 5z"/>', 'llamada'],
    ['<span class="lh-t">TPMS</span><span class="lh-s">Llantas en vivo</span>', '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="3.5"/><path d="M12 3.5v2M12 18.5v2M3.5 12h2M18.5 12h2"/>', 'llantas'],
  ];
  const PASO = 10, n = F.length, L = [];
  for (let k = -n; k < 2 * n; k++) {
    const f = F[((k % n) + n) % n], a = k * PASO + 'deg';
    const it = document.createElement('div'); it.className = 'lh-item'; it.style.setProperty('--a', a); it.innerHTML = '<svg viewBox="0 0 24 24">' + f[1] + '</svg><b>' + f[0] + '</b>';
    const nu = document.createElement('div'); nu.className = 'lh-num'; nu.style.setProperty('--a', a); nu.textContent = '0' + (((k % n) + n) % n + 1);
    const pu = document.createElement('div'); pu.className = 'lh-punto'; pu.style.setProperty('--a', a);
    giro.append(it, nu, pu); L.push([k, it, nu, pu]);
  }
  let i = 0;
  const mostrar = () => { giro.style.transform = 'rotate(' + (i * PASO) + 'deg)'; L.forEach(([k, ...els]) => els.forEach(e => e.classList.toggle('on', k === i))); };
  mostrar();
  const scr = document.querySelector('.nv-scr');
  const ir = app => { const t = F.findIndex(f => f[2] === app); if (t < 0) return;
    let paso = 0; while (((i % n) + n) % n !== t && paso < n) { i++; paso++; if (i >= n) { giro.style.transition = 'none'; i -= n; mostrar(); void giro.offsetWidth; giro.style.transition = ''; } }
    mostrar(); };
  if (scr) { new MutationObserver(() => ir(scr.dataset.app)).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); ir(scr.dataset.app || 'mapa'); }
})();

} catch (e) { console.error(e); }
try {

// v3b: en la ruta, la cámara trasera aparece en una ventanita a los 2,6 s (navegas y grabas a la vez)
(() => { const scr = document.querySelector('.nv-scr'); if (!scr) return; let t;
  new MutationObserver(() => { clearTimeout(t); scr.classList.remove('pip'); if (scr.dataset.app === 'mapa') t = setTimeout(() => scr.classList.add("pip"), 2600); })
    .observe(scr, { attributes: true, attributeFilter: ['data-app'] }); })();

} catch (e) { console.error(e); }
try {

// v3f: arranca la entrada del título cuando carga la página
(() => { const c = document.querySelector('.lh-caja'); if (!c) return; requestAnimationFrame(() => setTimeout(() => c.classList.add('on'), 150)); })();

} catch (e) { console.error(e); }
try {

(() => { const d = document.querySelector('header.nv-hero .nv-duo'), i = d && d.querySelector('img.nv-img[data-var="5"]:not(.nv-lado)'); if (!i) return;
  const f = () => { const a = i.getBoundingClientRect(), b = d.getBoundingClientRect(); d.style.setProperty('--sombra-top', (a.bottom - b.top - 12) + 'px'); d.style.setProperty('--sombra-w', (a.width * .86) + 'px'); };
  f(); addEventListener('resize', f); [500, 1500, 3000].forEach(t => setTimeout(f, t)); })();

} catch (e) { console.error(e); }
try {

(() => { const d = document.querySelector('header.nv-hero .nv-duo'), i = d && d.querySelector('img.nv-img[data-var="5"]:not(.nv-lado)'); if (!i) return;
  const sb = document.createElement('i'); sb.className = 'nv-sombra'; sb.setAttribute('aria-hidden', 'true'); d.appendChild(sb);
  const f = () => { const a = i.getBoundingClientRect(), b = d.getBoundingClientRect(), w = a.width * .9;
    sb.style.width = w + 'px'; sb.style.left = (a.left - b.left + (a.width - w) / 2) + 'px'; sb.style.top = (a.bottom - b.top - 14) + 'px'; };
  f(); addEventListener('resize', f); [400, 1200, 2500, 4000].forEach(t => setTimeout(f, t)); })();

} catch (e) { console.error(e); }
try {

// v3u: la indicación y la llegada cambian mientras el carro avanza (200 m → giro → sigue derecho → llegaste)
(() => { const scr = document.querySelector('.nv-scr'); if (!scr) return;
  const g = scr.querySelector('.cp-guia'), gs = g && g.querySelector('strong'), gt = gs && gs.nextSibling, ets = [...scr.querySelectorAll('.cp-eta strong')];
  if (!g || !gs) return; const txt0 = gt ? gt.textContent : 'Gira a la derecha'; let ts = [];
  const set = (d, t) => { gs.textContent = d; if (gt) gt.textContent = t; g.classList.toggle('izq', /izquierda/.test(t)); g.classList.toggle('recto', /derecho|Llegaste/.test(t) || /destino/.test(t)); g.classList.remove('giro'); void g.offsetWidth; g.classList.add('giro'); };
  const cuenta = (desde, hasta, ms, suf) => { const t0 = performance.now(); const f = n => { const k = Math.min((n - t0) / ms, 1); gs.textContent = Math.round(desde + (hasta - desde) * k) + suf; if (k < 1 && scr.dataset.app === 'mapa') requestAnimationFrame(f); }; requestAnimationFrame(f); };
  new MutationObserver(() => { ts.forEach(clearTimeout); ts = [];
    if (scr.dataset.app !== 'mapa') return;
    set('200 m', txt0); if (ets[1]) ets[1].textContent = '12'; if (ets[2]) ets[2].textContent = '5,4';
    ts.push(setTimeout(() => cuenta(200, 0, 2600, ' m'), 1300));
    ts.push(setTimeout(() => { set('450 m', 'Sigue derecho'); cuenta(450, 0, 3200, ' m'); if (ets[1]) ets[1].textContent = '11'; if (ets[2]) ets[2].textContent = '4,9'; }, 4100));
    ts.push(setTimeout(() => { set('120 m', 'Gira a la izquierda'); cuenta(120, 0, 2000, ' m'); if (ets[1]) ets[1].textContent = '10'; if (ets[2]) ets[2].textContent = '4,3'; }, 7400));
    ts.push(setTimeout(() => { set('Llegaste', 'Tu destino está a la derecha'); }, 9700));
  }).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); })();

} catch (e) { console.error(e); }
try {

// v3v: la tarjeta de Waze cuenta la distancia y cambia de instrucción al girar, sincronizada con el mapa
(() => { const scr = document.querySelector('.nv-scr'); if (!scr || !scr.querySelector('.wz')) return;
  const card = scr.querySelector('.wz-card'), d = scr.querySelector('.wz-d'), c = scr.querySelector('.wz-c'), fl = scr.querySelector('.wz-fl svg'),
        mn = scr.querySelector('.wz-min'), km = scr.querySelector('.wz-km'); let ts = [], raf;
  const cuenta = (a, b, ms) => { cancelAnimationFrame(raf); const t0 = performance.now(); const f = n => { const k = Math.min((n - t0) / ms, 1); d.textContent = Math.round(a + (b - a) * k) + ' m'; if (k < 1) raf = requestAnimationFrame(f); }; raf = requestAnimationFrame(f); };
  const ini = () => { card.classList.remove('recto'); if (fl.dataset.orig) fl.innerHTML = fl.dataset.orig; c.textContent = 'Calle 9ª'; mn.textContent = '26'; km.textContent = '5.8'; scr.classList.remove('wz-giro'); };
  new MutationObserver(() => { ts.forEach(clearTimeout); ts = []; cancelAnimationFrame(raf);
    if (scr.dataset.app !== 'mapa') return; ini(); cuenta(160, 0, 2900);
    ts.push(setTimeout(() => { scr.classList.add('wz-giro'); }, 3000));
    ts.push(setTimeout(() => { card.classList.add('recto'); fl.dataset.orig = fl.dataset.orig || fl.innerHTML; fl.innerHTML = '<path d="M24 44V8M12 20L24 6l12 14" fill="none" stroke="#fff" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>'; c.textContent = 'Transversal 42'; km.textContent = '5.6'; mn.textContent = '25'; cuenta(400, 250, 1800); }, 3800));
  }).observe(scr, { attributes: true, attributeFilter: ['data-app'] }); })();

} catch (e) { console.error(e); }
try {

(() => { const d = document.querySelector('header.nv-hero .nv-duo'), i = d && d.querySelector('img.nv-img[data-var="5"]:not(.nv-lado)'); if (!i) return;
  const c = document.createElement('div'); c.className = 'nv-cams2'; c.setAttribute('aria-hidden', 'true');
  c.innerHTML = '<img src="/cdn/shop/files/nv6p-x-cam-i.webp" alt="" decoding="async"><img src="/cdn/shop/files/nv6p-x-cam-d.webp" alt="" decoding="async">'; d.appendChild(c);
  const f = () => { const a = i.getBoundingClientRect(), b = d.getBoundingClientRect(), cw = Math.round(a.width * .13);
    c.style.setProperty('--cw', cw + 'px'); c.style.left = (a.left - b.left - cw * .35) + 'px'; c.style.top = (a.bottom - b.top - cw * 1.05) + 'px'; };
  f(); addEventListener('resize', f); [400, 1200, 2500].forEach(t => setTimeout(f, t)); setTimeout(() => { f(); c.classList.add('on'); }, 1200); })();

} catch (e) { console.error(e); }
try {

(() => { const d = document.querySelector('header.nv-hero .nv-duo'), i = d && d.querySelector('img.nv-img[data-var="5"]:not(.nv-lado)'); if (!i) return;
  const L = document.createElement('img'), R = document.createElement('img');
  L.src = '/cdn/shop/files/nv6p-x-cam-i.webp'; R.src = '/cdn/shop/files/nv6p-x-cam-d.webp'; [L, R].forEach(e => { e.className = 'nv-cam1'; e.alt = ''; e.setAttribute('aria-hidden', 'true'); d.appendChild(e); });
  const f = () => { const a = i.getBoundingClientRect(), b = d.getBoundingClientRect(), cw = Math.round(a.width * .2), ch = cw * 1.15;
    [L, R].forEach(e => { e.style.setProperty('width', cw + 'px', 'important'); e.style.setProperty('max-width', cw + 'px', 'important'); e.style.setProperty('height', 'auto', 'important'); e.style.setProperty('position', 'absolute', 'important'); e.style.setProperty('z-index', '80', 'important'); e.style.setProperty('transform', 'none', 'important'); e.style.setProperty('margin', '0', 'important'); e.style.setProperty('right', 'auto', 'important'); e.style.setProperty('bottom', 'auto', 'important'); });
    const top = a.bottom - b.top - ch * .32;
    L.style.setProperty('left', Math.max(0, a.left - b.left - cw * .6) + 'px', 'important'); L.style.setProperty('top', top + 'px', 'important');
    R.style.setProperty('left', Math.min(b.width - cw, a.right - b.left - cw * .4) + 'px', 'important'); R.style.setProperty('top', top + 'px', 'important'); };
  addEventListener('resize', f); L.classList.add('on'); R.classList.add('on'); })();

} catch (e) { console.error(e); }
try {

(() => { const d = document.querySelector('header.nv-hero .nv-duo'), i = d && d.querySelector('img.nv-img[data-var="5"]:not(.nv-lado)'), cams = d && [...d.querySelectorAll('img.nv-cam1')]; if (!cams || cams.length < 2) return;
  const [L, R] = cams; L.classList.add('izq'); R.classList.add('der');
  const P = cams.map(() => { const e = document.createElement('i'); e.className = 'nv-cam-piso'; e.setAttribute('aria-hidden', 'true'); d.appendChild(e); return e; });
  const f = () => { const a = i.getBoundingClientRect(), b = d.getBoundingClientRect(), cw = Math.round(a.width * .17), ch = cw * 1.15, base = a.bottom - b.top + ch * .42;
    cams.forEach((e, k) => { e.style.setProperty('width', cw + 'px', 'important'); e.style.setProperty('max-width', cw + 'px', 'important');
      e.style.setProperty('top', (base - ch) + 'px', 'important');
      const x = k ? Math.min(b.width - cw - 2, a.right - b.left - cw * .3) : Math.max(2, a.left - b.left - cw * .7);
      e.style.setProperty('left', x + 'px', 'important');
      P[k].style.width = (cw * .9) + 'px'; P[k].style.left = (x + cw * .05) + 'px'; P[k].style.top = (base - 6) + 'px'; }); };
  addEventListener('resize', f);
  setTimeout(() => P.forEach(e => e.classList.add('on')), 1300); })();

} catch (e) { console.error(e); }
try {

(() => { const d = document.querySelector('header.nv-hero .nv-duo'), scr = d && d.querySelector('.nv-scr'); if (!scr) return;
  const go = () => { if (d.classList.contains('cams-go')) return; window.dispatchEvent(new Event('resize')); requestAnimationFrame(() => d.classList.add('cams-go')); };
  if (scr.classList.contains('on')) setTimeout(go, 500);
  else new MutationObserver((m, o) => { if (scr.classList.contains('on')) { o.disconnect(); setTimeout(go, 500); } }).observe(scr, { attributes: true, attributeFilter: ['class'] });
  setTimeout(go, 4500); })();

} catch (e) { console.error(e); }
try {
(() => requestAnimationFrame(() => setTimeout(() => document.body.classList.add('jer-on'), 150)))();
} catch (e) { console.error(e); }
try {

(() => { const c = document.querySelector('.lh-caja');
  const go = () => { document.body.classList.add('jer-on'); if (c) c.classList.add('on'); };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => requestAnimationFrame(go)); else requestAnimationFrame(go);
  setTimeout(go, 1200); })();

} catch (e) { console.error(e); }
try {

(() => { const bs = [...document.querySelectorAll('.tx-sel button')];
  const pick = v => { document.body.classList.remove('tx-a','tx-b','tx-c','tx-b1','tx-b2','tx-b3','tx-t1','tx-t2','tx-t3'); document.body.classList.add('tx-b', 'tx-b3', 'tx-' + v); bs.forEach(b => b.classList.toggle('on', b.dataset.v === v)); window.dispatchEvent(new Event('resize')); };
  bs.forEach(b => b.addEventListener('click', () => pick(b.dataset.v))); pick('t1'); })();

} catch (e) { console.error(e); }
try {
document.body.classList.add('tx-b','tx-b3','tx-t1');
} catch (e) { console.error(e); }
try {

document.querySelectorAll('[data-pc]').forEach(c => {
  const t = c.querySelector('.pc-track'), sl = [...t.children], d = [...c.querySelectorAll('.pc-dots i')];
  const upd = () => { const x = t.scrollLeft + t.clientWidth / 2; let k = 0, best = 1e9; sl.forEach((e, n) => { const m = Math.abs(e.offsetLeft + e.offsetWidth / 2 - x); if (m < best) { best = m; k = n; } }); d.forEach((e, n) => e.classList.toggle('on', n === k)); };
  t.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true }); upd();
});

} catch (e) { console.error(e); }
try {

document.querySelectorAll('[data-pc]').forEach(c => { const t = c.querySelector('.pc-track'); c.querySelectorAll('.pc-btn').forEach(b => b.addEventListener('click', () => t.scrollBy({ left: b.dataset.d * (t.children[0].offsetWidth + 12), behavior: 'smooth' }))); });

} catch (e) { console.error(e); }
try {

(() => { const w = document.querySelector('.so-wm'); if (!w) return; if (!('IntersectionObserver' in window)) { w.classList.add('go'); return; }
  new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { w.classList.add('go'); o.disconnect(); } }), { threshold: .4 }).observe(w.parentElement); })();

} catch (e) { console.error(e); }
try {

document.querySelectorAll('.dv-player').forEach(p => {
  const vs = [...p.querySelectorAll('video')], bs = [...p.querySelectorAll('.dv-tabs button')];
  const show = k => { bs.forEach(b => b.classList.toggle('on', b.dataset.v === k)); vs.forEach(v => { const on = v.dataset.v === k; v.classList.toggle('on', on); if (on) { v.preload = 'auto'; v.play().catch(() => {}); } else v.pause(); }); };
  bs.forEach(b => b.addEventListener('click', () => show(b.dataset.v)));
  if ('IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(e => { const v = p.querySelector('video.on'); if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); }), { threshold: .25 }).observe(p);
});

} catch (e) { console.error(e); }
try {

(() => { const c = document.querySelector('.dv-cams'); if (!c) return; if (!('IntersectionObserver' in window)) { c.classList.add('dv-in'); return; }
  new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { c.classList.add('dv-in'); o.disconnect(); } }), { threshold: .35 }).observe(c); })();

} catch (e) { console.error(e); }
try {

(() => { const v = document.querySelector('video[data-src]'); if (!v) return;
  let listo = false, visible = false;
  const intenta = () => { if (listo && visible) v.play().catch(() => {}); };
  v.addEventListener('canplaythrough', () => { listo = true; intenta(); }, { once: true });
  const carga = () => { if (!v.src) { v.preload = 'auto'; v.src = v.dataset.src; v.load(); } };
  if (!('IntersectionObserver' in window)) { carga(); visible = true; return; }
  new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { carga(); o.disconnect(); } }), { rootMargin: '1600px 0px' }).observe(v);
  new IntersectionObserver(es => es.forEach(e => { visible = e.isIntersecting; if (visible) intenta(); else v.pause(); }), { threshold: .3 }).observe(v); })();

} catch (e) { console.error(e); }
try {

(() => { const c = document.querySelector('.tp-moto'); if (!c) return;
  const run = () => { c.classList.add('tp-on'); c.querySelectorAll('[data-to]').forEach(b => { const to = +b.dataset.to, t0 = performance.now(); const f = t => { const k = Math.min((t - t0) / 1400, 1); b.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(f); }; requestAnimationFrame(f); }); };
  if (!('IntersectionObserver' in window)) { run(); return; }
  new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { run(); o.disconnect(); } }), { threshold: .4 }).observe(c); })();

} catch (e) { console.error(e); }
try {
(()=>{if(!('IntersectionObserver'in window))return;const io=new IntersectionObserver(es=>es.forEach(e=>e.target.classList.toggle('fuera',!e.isIntersecting)),{rootMargin:'300px 0px'});document.querySelectorAll('section.sec').forEach(x=>io.observe(x))})();
} catch (e) { console.error(e); }
try {
(()=>{const hero=document.querySelector('.nv-hero'),d=hero&&hero.querySelector('.lh-dial');if(!d)return;
const f=()=>{if(innerWidth<900){d.classList.remove('r-on');d.style.top='';return}
const cs=getComputedStyle(hero),w=parseFloat(cs.getPropertyValue('--w'))||520,t=parseFloat(cs.getPropertyValue('--dial-top'));if(isNaN(t))return;
const R=Math.max(w,Math.pow(innerWidth*1.3/2,2)/(2*1.24*.42*w)/1.24);
d.style.setProperty('--R',R+'px');d.classList.add('r-on');d.style.top=(t+2.48*w-2.48*R-(innerWidth>=1300?95:15))+'px'};
addEventListener('load',f);addEventListener('resize',f);[350,950,2050,3600].forEach(x=>setTimeout(f,x))})();
} catch (e) { console.error(e); }